export default [
  {
    "name": "England",
    "values": [
      {
        "name": "Bedfordshire",
        "abbreviation": "BDF"
      },
      {
        "name": "Berkshire",
        "abbreviation": "BRK"
      },
      {
        "name": "Bristol",
        "abbreviation": "BRL"
      },
      {
        "name": "Buckinghamshire",
        "abbreviation": "BKM"
      },
      {
        "name": "Cambridgeshire",
        "abbreviation": "CAM"
      },
      {
        "name": "Cheshire",
        "abbreviation": "CHS"
      },
      {
        "name": "Cleveland",
        "abbreviation": "CLV"
      },
      {
        "name": "Cornwall",
        "abbreviation": "CON"
      },
      {
        "name": "County Durham",
        "abbreviation": "DUR"
      },
      {
        "name": "Cumbria",
        "abbreviation": "CMA"
      },
      {
        "name": "Derbyshire",
        "abbreviation": "DBY"
      },
      {
        "name": "Devon",
        "abbreviation": "DEV"
      },
      {
        "name": "Dorset",
        "abbreviation": "DOR"
      },
      {
        "name": "East Riding of Yorkshire",
        "abbreviation": "ERY"
      },
      {
        "name": "East Sussex",
        "abbreviation": "SXE"
      },
      {
        "name": "Essex",
        "abbreviation": "ESS"
      },
      {
        "name": "Gloucestershire",
        "abbreviation": "GLS"
      },
      {
        "name": "Greater London",
        "abbreviation": "GRL"
      },
      {
        "name": "Greater Manchester",
        "abbreviation": "GRM"
      },
      {
        "name": "Hampshire",
        "abbreviation": "HAM"
      },
      {
        "name": "Herefordshire",
        "abbreviation": "HEF"
      },
      {
        "name": "Hertfordshire",
        "abbreviation": "HRT"
      },
      {
        "name": "Isle of Wight",
        "abbreviation": "IOW"
      },
      {
        "name": "Kent",
        "abbreviation": "KEN"
      },
      {
        "name": "Lancashire",
        "abbreviation": "LAN"
      },
      {
        "name": "Leicestershire",
        "abbreviation": "LEI"
      },
      {
        "name": "Lincolnshire",
        "abbreviation": "LIN"
      },
      {
        "name": "City of London",
        "abbreviation": "LDN"
      },
      {
        "name": "Merseyside",
        "abbreviation": "MSY"
      },
      {
        "name": "Middlesex",
        "abbreviation": "MDX"
      },
      {
        "name": "Norfolk",
        "abbreviation": "NFK"
      },
      {
        "name": "Northamptonshire",
        "abbreviation": "NTH"
      },
      {
        "name": "Northumberland",
        "abbreviation": "NBL"
      },
      {
        "name": "North Yorkshire",
        "abbreviation": "NYK"
      },
      {
        "name": "Nottinghamshire",
        "abbreviation": "NTT"
      },
      {
        "name": "Oxfordshire",
        "abbreviation": "OXF"
      },
      {
        "name": "Rutland",
        "abbreviation": "RUT"
      },
      {
        "name": "Shropshire",
        "abbreviation": "SAL"
      },
      {
        "name": "Somerset",
        "abbreviation": "SOM"
      },
      {
        "name": "South Yorkshire",
        "abbreviation": "SYK"
      },
      {
        "name": "Staffordshire",
        "abbreviation": "STS"
      },
      {
        "name": "Suffolk",
        "abbreviation": "SFK"
      },
      {
        "name": "Surrey",
        "abbreviation": "SRY"
      },
      {
        "name": "Tyne and Wear",
        "abbreviation": "TWR"
      },
      {
        "name": "Warwickshire",
        "abbreviation": "WAR"
      },
      {
        "name": "West Midlands",
        "abbreviation": "WMD"
      },
      {
        "name": "West Sussex",
        "abbreviation": "SXW"
      },
      {
        "name": "West Yorkshire",
        "abbreviation": "WYK"
      },
      {
        "name": "Wiltshire",
        "abbreviation": "WIL"
      },
      {
        "name": "Worcestershire",
        "abbreviation": "WOR"
      }
    ]
  },
  {
    "name": "Scotland",
    "values": [
      {
        "name": "Aberdeenshire",
        "abbreviation": "ABD"
      },
      {
        "name": "Angus",
        "abbreviation": "ANS"
      },
      {
        "name": "Argyll",
        "abbreviation": "ARL"
      },
      {
        "name": "Ayrshire",
        "abbreviation": "AYR"
      },
      {
        "name": "Banffshire",
        "abbreviation": "BAN"
      },
      {
        "name": "Berwickshire",
        "abbreviation": "BEW"
      },
      {
        "name": "Bute",
        "abbreviation": "BUT"
      },
      {
        "name": "Caithness",
        "abbreviation": "CAI"
      },
      {
        "name": "Clackmannanshire",
        "abbreviation": "CLK"
      },
      {
        "name": "Dumfriesshire",
        "abbreviation": "DGY"
      },
      {
        "name": "Dunbartonshire",
        "abbreviation": "DNB"
      },
      {
        "name": "East Lothian",
        "abbreviation": "ELN"
      },
      {
        "name": "Fife",
        "abbreviation": "FIF"
      },
      {
        "name": "Inverness-shire",
        "abbreviation": "INV"
      },
      {
        "name": "Kincardineshire",
        "abbreviation": "KCD"
      },
      {
        "name": "Kinross-shire",
        "abbreviation": "KRS"
      },
      {
        "name": "Kirkcudbrightshire",
        "abbreviation": "KKD"
      },
      {
        "name": "Lanarkshire",
        "abbreviation": "LKS"
      },
      {
        "name": "Midlothian",
        "abbreviation": "MLN"
      },
      {
        "name": "Morayshire",
        "abbreviation": "MOR"
      },
      {
        "name": "Nairnshire",
        "abbreviation": "NAI"
      },
      {
        "name": "Orkney",
        "abbreviation": "OKI"
      },
      {
        "name": "Peeblesshire",
        "abbreviation": "PEE"
      },
      {
        "name": "Perthshire",
        "abbreviation": "PER"
      },
      {
        "name": "Renfrewshire",
        "abbreviation": "RFW"
      },
      {
        "name": "Ross-shire",
        "abbreviation": "ROC"
      },
      {
        "name": "Roxburghshire",
        "abbreviation": "ROX"
      },
      {
        "name": "Selkirkshire",
        "abbreviation": "SEL"
      },
      {
        "name": "Shetland",
        "abbreviation": "SHI"
      },
      {
        "name": "Stirlingshire",
        "abbreviation": "STI"
      },
      {
        "name": "Sutherland",
        "abbreviation": "SUT"
      },
      {
        "name": "West Lothian",
        "abbreviation": "WLN"
      },
      {
        "name": "Wigtownshire",
        "abbreviation": "WIG"
      }
    ]
  },
  {
    "name": "Wales",
    "values": [
      {
        "name": "Blaenau Gwent",
        "abbreviation": "BGW"
      },
      {
        "name": "Bridgend",
        "abbreviation": "BGD",
      },
      {
        "name": "Caerphilly",
        "abbreviation": "CAP",
      },
      {
        "name": "Cardiff",
        "abbreviation": "CRD",
      },
      {
        "name": "Carmarthenshire",
        "abbreviation": "CRM",
      },
      {
        "name": "Ceredigion",
        "abbreviation": "CDN"
      },
      {
        "name": "Conwy",
        "abbreviation": "CDN"
      },
      {
        "name": "Denbighshire",
        "abbreviation": "DBS"
      },
      {
        "name": "Flintshire",
        "abbreviation": "FLT"
      },
      {
        "name": "Gwynedd",
        "abbreviation": "GWN"
      },
      {
        "name": "Isle of Anglesey",
        "abbreviation": "IOA"
      },
      {
        "name": "Merthyr Tydfil",
        "abbreviation": "MTF"
      },
      {
        "name": "Monmouthshire",
        "abbreviation": "MMS"
      },
      {
        "name": "Neath Port Talbot",
        "abbreviation": "NPT"
      },
      {
        "name": "Newport",
        "abbreviation": "NPT"
      },
      {
        "name": "Pembrokeshire",
        "abbreviation": "PEM"
      },
      {
        "name": "Powys",
        "abbreviation": "POW"
      },
      {
        "name": "Rhondda Cynon Taf",
        "abbreviation": "RCT"
      },
      {
        "name": "Swansea",
        "abbreviation": "SWA"
      },
      {
        "name": "Torfaen",
        "abbreviation": "TOR"
      },
      {
        "name": "Vale of Glamorgan",
        "abbreviation": "VOG"
      },
      {
        "name": "Wrexham",
        "abbreviation": "WHM"
      }
    ]
  },
  {
    "name": "Northern Ireland",
    "values": [
      {
        "name": "Antrim",
        "abbreviation": "ANT"
      },
      {
        "name": "Armagh",
        "abbreviation": "ARM"
      },
      {
        "name": "Down",
        "abbreviation": "DOW"
      },
      {
        "name": "Fermanagh",
        "abbreviation": "FER"
      },
      {
        "name": "Londonderry",
        "abbreviation": "LDY"
      },
      {
        "name": "Tyrone",
        "abbreviation": "TYR"
      }
    ]
  }
]
